var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoPagerduty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 11.269h2.052V15H3zM10.728 1.684C9.627 1.098 8.863 1 7.06 1H3v8.492h4.042c1.608 0 2.807-.097 3.864-.8 1.155-.763 1.75-2.033 1.75-3.5 0-1.59-.737-2.86-1.928-3.508M7.513 7.716H5.052V2.82l2.319-.018c2.114-.026 3.17.72 3.17 2.408 0 1.812-1.305 2.505-3.028 2.505"
})));
export default SvgLogoPagerduty;